import { AppModel } from '../../../modules/Apps';

import { ScopesTableBody } from './ScopesTableBody';
import { ScopesTableEmptyState } from './ScopesTableEmptyState';
import { ScopesTableErrorState } from './ScopesTableErrorState';
import { ScopesTableLoadingState } from './ScopesTableLoadingState';

interface ScopesTableContentProps {
  app?: AppModel;
  isLoading: Boolean;
  isError: Boolean;
}

export function ScopesTableContent({ app, isError, isLoading }: ScopesTableContentProps) {
  if (isLoading) {
    return <ScopesTableLoadingState />;
  }

  if (isError) {
    return <ScopesTableErrorState />;
  }

  if (!app) {
    return <ScopesTableErrorState message="Invalid App" />;
  }

  if (!app.scopes?.length) {
    return <ScopesTableEmptyState />;
  }

  return <ScopesTableBody app={app} />;
}
